// extracted by mini-css-extract-plugin
export default {"wrapper":"FocusAddTaskInput_wrapper__or-w2","plus":"FocusAddTaskInput_plus__-o9s5","input":"FocusAddTaskInput_input__jrqFk"};